<template>
  <TransitionGroup
    :appear="appear"
    :name="transitionName"
    :tag="tag"
    :class="listClass"
  >
    <component
      :is="itemTag"
      v-for="(item, index) in items"
      :key="resolveItemKey(item, index)"
      :class="itemClass"
      :style="itemStyle(index)"
    >
      <slot :item="item" :index="index" />
    </component>
  </TransitionGroup>
</template>

<script setup>
const props = defineProps({
  appear: {
    type: Boolean,
    default: true,
  },
  items: {
    type: Array,
    default: () => [],
  },
  itemClass: {
    type: String,
    default: '',
  },
  itemKey: {
    type: [String, Function],
    default: 'id',
  },
  itemTag: {
    type: String,
    default: 'div',
  },
  listClass: {
    type: String,
    default: '',
  },
  maxDelayMs: {
    type: Number,
    default: 240,
  },
  staggerMs: {
    type: Number,
    default: 60,
  },
  tag: {
    type: String,
    default: 'div',
  },
  transitionName: {
    type: String,
    default: 'umisis-animated-list',
  },
})

const itemStyle = (index) => {
  const staggerDelay = Math.min(index * props.staggerMs, props.maxDelayMs)

  return {
    transitionDelay: `${staggerDelay}ms`,
  }
}

const resolveItemKey = (item, index) => {
  if (typeof props.itemKey === 'function') {
    return props.itemKey(item, index)
  }

  if (typeof props.itemKey === 'string' && item !== null && typeof item === 'object') {
    return item[props.itemKey] ?? index
  }

  return index
}
</script>

<style scoped>
.umisis-animated-list-enter-active,
.umisis-animated-list-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.umisis-animated-list-enter-from,
.umisis-animated-list-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
